<template>
  <div class="changePhone">
    <div class="header">
      <div class="header-slot">
        修改手机号
      </div>
      <div @click="revertUpper">
        <div class="revert">返回</div>
      </div>
    </div>

    <div class="content">
      <el-form
        label-width="80px"
        :model="ruleForm"
        label-position="top"
        :rules="rules"
        ref="ruleForm"
        size="small"
      >
        <div class="content-top">
          <el-form-item
            label="原手机号"
            prop="pass"
            style="width: 610px;"
          >
            <el-input
              type="text"
              clearable
              v-model.number="ruleForm.pass"
              autocomplete="off"
              placeholder="请输入原手机"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="新手机号"
            clearable
            prop="phone"
            style="width: 610px; margin: 40px 0;"
          >
            <el-input
              type="text"
              clearable
              v-model="ruleForm.phone"
              autocomplete="off"
              placeholder="请输入新手机号"
            ></el-input>
          </el-form-item>
        </div>

        <div class="content-bottom">
          <el-form-item
            label="验证码"
            prop="code"
            style="width: 610px"
          >
            <el-input
              type="text"
              v-model="ruleForm.code"
              autocomplete="off"
              placeholder="请输入验证码"
            ></el-input>
          </el-form-item>
          <div class="content-bottom-btn">
            <get-code
              :ruleForm="ruleForm"
              :type="'INFO'"
            />
          </div>
        </div>

        <el-form-item class="btn">
          <el-button
            style="background-color: #484c7f;color: #fff;"
            @click="submitForm('ruleForm')"
            v-prevent="3000"
          >保存</el-button>
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>

<script>
import getCode from '../../../components/getCode/index.vue'
import PersonalCenterHead from '../../../components/PersonalCenterHead/index.vue'
export default {
  name: 'changePhone',
  components: {
    PersonalCenterHead,
    getCode
  },
  data () {
    var validatePass1 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('原手机号不能为空'));
      }
      callback();
    };
    var validatePass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('新手机号不能为空'));
      }
      callback();
    };
    var validatePass2 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('验证码不能为空'));
      }
      callback();
    };
    return {
      ruleForm: {
        pass: '', //旧
        code: '',
        phone: '' //新
      },
      rules: {
        phone: [
          { validator: validatePass, trigger: 'blur' }
        ],
        code: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        pass: [
          { validator: validatePass1, trigger: 'blur' }
        ]
      },
    };
  },
  methods: {
    revertUpper () {
      this.$router.push('/datum')
    },
    async getUserChangePhone () {
      const { data: data } = await this.$http.post("user/changePhone", {
        oldPhone: this.ruleForm.pass, //旧
        phone: this.ruleForm.phone,//新
        code: this.ruleForm.code //code 
      })
      this.$message({
        message: data.message,
        type: 'success'
      });
    },
    //提交
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.phone == this.ruleForm.pass) {
            this.$message.error('新手机号与旧手机号不能相同')
            return
          };
          this.getUserChangePhone()
        } else {
          return false;
        }
      });
    },
  }
}

</script>
<style lang="less" scoped>
.changePhone {
  padding: 0 0 50px 0;
  height: 97%;
  .content {
    position: relative;
    height: 100%;
    margin-top: 23px;
    padding: 25px 15px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    background-color: #fff;

    // .content-top {
    //   display: flex;
    // }
    .content-bottom {
      display: flex;
      align-items: center;
      .content-bottom-btn {
        margin-left: 53px;
        margin-top: 7px;
      }
    }
  }
  & /deep/ .el-form-item__label {
    font-size: 14px;
    color: #606266;
    padding-bottom: 15px;
    line-height: 16px;
    &::before {
      content: "*";
      color: #ff0000;
      padding-right: 5px;
      font-weight: 600;
    }
  }

  .btn {
    position: absolute;
    bottom: 0px;
    left: 15px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
    .header-slot {
      font-size: 28px;
      color: #212529;
      font-weight: 600;
    }
    .revert {
      width: 50px;
      height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 13px;
      color: #ffffff;
      background-color: #6c757d;
      border-radius: 4px;
      cursor: pointer;
      transition: 0.5s all;
      // &:hover {
      //   background-color: #6c759d;
      // }
    }
  }
}
</style>